import ExperimentKey from "../../Experiment/types/ExperimentKey";
import ExperimentalFlowResolver from "../types/ExperimentalFlowResolver";
import { Flow } from "../types/IFlow";
import { NoConfirmationNewPatientFlowLegacyNames } from "../types/FlowNames";
import {
  SingleMedicalStepDefaultNavigatorConfiguration,
  SingleMedicalStepPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import NoConfirmationNewPatientFlow, { PreQualifiedNoConfirmationNewPatientFlow } from "./NoConfirmationNewPatientFlow";
import {
  experimentalScreeningStepConfigurations,
  noConfirmationCenterSelectableBookingStepConfigurations
} from "./StepConfigurations";

const singleMedicalStepNewPatientFlowName = "SingleMedicalStepNewPatientFlow";

/** The treatment flow where a new patient experiences the single-page medical presentation. */
class SingleMedicalStepNewPatientFlow extends Flow {
  static readonly flowName = singleMedicalStepNewPatientFlowName;
  readonly name = singleMedicalStepNewPatientFlowName;
  readonly steps = {
    ...experimentalScreeningStepConfigurations,
    ...noConfirmationCenterSelectableBookingStepConfigurations
  };
  readonly navigatorItems = SingleMedicalStepDefaultNavigatorConfiguration;
  isDisqualificationPossible() {
    return true;
  }
  override matchesFlowName(name: string): boolean {
    return this.name === name || NoConfirmationNewPatientFlowLegacyNames.includes(name);
  }
}

/** The treatment flow for pre-qualified new patients (scheduling-only path). */
export class PreQualifiedSingleMedicalStepNewPatientFlow extends Flow {
  readonly name = singleMedicalStepNewPatientFlowName;
  readonly steps = { ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = SingleMedicalStepPreQualifiedPatientNavigatorConfiguration;
  isDisqualificationPossible() {
    return false;
  }
  override matchesFlowName(name: string): boolean {
    return this.name === name || NoConfirmationNewPatientFlowLegacyNames.includes(name);
  }
}

export default SingleMedicalStepNewPatientFlow;

/** Resolves new-patient flows through the single-medical-step experiment when the session flow name matches the control family. */
export const SingleMedicalStepNewPatientFlowResolver = new ExperimentalFlowResolver(
  new SingleMedicalStepNewPatientFlow(),
  new NoConfirmationNewPatientFlow(),
  ExperimentKey.SingleMedicalStepFlow
);

/** Resolves pre-qualified new-patient flows through the single-medical-step experiment. */
export const PreQualifiedSingleMedicalStepNewPatientFlowResolver = new ExperimentalFlowResolver(
  new PreQualifiedSingleMedicalStepNewPatientFlow(),
  new PreQualifiedNoConfirmationNewPatientFlow(),
  ExperimentKey.SingleMedicalStepFlow
);
